import { updateServiceConfig } from 'owa-service/lib/config';
import { isNetworkBlocked } from './offlineBoot';

export function setDisableAllRequests(value: boolean): void {
    updateServiceConfig({
        disableAllRequests: value,
    });
}

export function disableRequestsWhenOffline(): void {
    const isBlocked = isNetworkBlocked();
    if (isBlocked) {
        setDisableAllRequests(true);
    }
}
